import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-primary-btn',
  imports: [],
  templateUrl: './primary-btn.component.html',
  styleUrl: './primary-btn.component.scss',
})
export class PrimaryBtnComponent {
  @Input() label!: string;
  @Input() icon: string = 'bi-plus-circle';
  @Input() type: 'primary' | 'secondary' | 'danger' = 'primary';

  @Output() action = new EventEmitter<void>();

  handleClick() {
    this.action.emit();
  }
}
